// User Roles
export const USER_ROLES = {
  INSTRUCTOR: 'instructor',
  STUDENT: 'student',
  TA: 'ta'
};

// Difficulty Badges Configuration
export const DIFFICULTY_BADGES = {
  easy: { bg: 'success', text: 'Easy' },
  medium: { bg: 'warning', text: 'Medium' },
  hard: { bg: 'danger', text: 'Hard' }
};

// Topics
export const TOPICS = [
  'Functions',
  'Expressions', 
  'Conditionals',
  'Loops and Iteration',
  'Strings',
  'Lists',
  'Tuples',
  'Modules',
  'Dictionaries',
  'Try Except Blocks',
  'File I/O and CSV',
  'API',
  'Recursion',
  'OOP'
];

// Routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  INSTRUCTOR: '/instructor',
  QUESTION_TABLE: '/questionTable',
  SUBMISSION_TABLE: '/submissionTable',
  TOPICS: '/topics'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  LOGGED_IN: 'loggedIn',
  STUDENT_ID: 'studentID',
  LOGIN_ID: 'loginID',
  ROLE_DATA: 'roleData',
  USER_CODE: 'userCode',
  COMPLETED_QUESTIONS: 'completedQuestions',
  USER_NAME: 'userName' // Cached from SSO
};

// Theme Colors
export const THEME_COLORS = {
  PRIMARY: '#a4925a',
  SECONDARY: '#45818e',
  SUCCESS: 'green',
  DANGER: 'red',
  WARNING: 'orange'
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  CONSENT_REQUIRED: 'You must consent to the data policy to sign up',
  CODE_REQUIRED: 'Please write some code before submitting'
};